export default "__VITE_ASSET__DPe3Oifk__"